export default __webpack_public_path__ + "media/images/quote-a5251e5e7e892a26954b759a09857247.svg";